import { all, takeEvery, select, put } from "redux-saga/effects";
import { getUsersRequest, UsersPageUrl, postUserRequest, deleteUserRequest } from "@common";
import { LocationChangeAction, LOCATION_CHANGE } from "react-router-redux";
import { createUserAction, changeCreateUserModalStatusAction, removeUserByIdAction } from "./actions";
import { createUserForm } from "./state";
import { AppState } from "../store";
import { openNotificationAction } from "../page";
import { FETCH_STATE_SUCCESS } from "rd-redux-http";
import { changeSaveOrPurchaseProcessingAction } from "../campaign";

function* getUsers() {
    try {
        const state: AppState = yield select();

        if (state.usersState.usersList.fetchState === FETCH_STATE_SUCCESS) {
            return;
        }

        yield* getUsersRequest.saga({});
    } catch (e) {
        console.log(e);
    }
}

function* createUser() {
    try {
        yield put(createUserForm.actions.reset());
        const state: AppState = yield select();

        const customerId =
            state.pagesState.customer.fetchState === FETCH_STATE_SUCCESS && state.pagesState.customer.data.customer.id;

        const createUserFormData = createUserForm.selector(state.usersState.createUserForm);

        if (!createUserFormData.isValid) {
            yield put(createUserForm.actions.validate());
            yield put(
                openNotificationAction({
                    isOpen: true,
                    isWarning: true,
                    message: "User didn't create! Validation error: Please, check your form"
                })
            );

            return;
        }
        yield put(changeSaveOrPurchaseProcessingAction({ isProcessing: true }));

        yield* postUserRequest.saga({}, { "customer-id": customerId, email: createUserFormData.data.email });

        yield* getUsersRequest.saga({});

        yield put(changeSaveOrPurchaseProcessingAction({ isProcessing: false }));
        yield put(changeCreateUserModalStatusAction({ isOpen: false }));
        yield put(
            openNotificationAction({
                isOpen: true,
                message: "User created!"
            })
        );
    } catch (e) {
        console.log(e);
        yield put(changeCreateUserModalStatusAction({ isOpen: false }));
        yield put(changeSaveOrPurchaseProcessingAction({ isProcessing: false }));
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "User didn't create! Please, try later"
            })
        );
    }
}

function* deleteUser(action: typeof removeUserByIdAction.typeInterface) {
    try {
        yield put(changeSaveOrPurchaseProcessingAction({ isProcessing: true }));
        yield* deleteUserRequest.saga({ userId: action.userId });
        yield* getUsersRequest.saga({});
        yield put(changeSaveOrPurchaseProcessingAction({ isProcessing: false }));
        yield put(
            openNotificationAction({
                isOpen: true,
                message: "User was deleted!"
            })
        );
    } catch (e) {
        console.log(e);
        yield put(changeSaveOrPurchaseProcessingAction({ isProcessing: false }));
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "User didn't delete! Please, try later"
            })
        );
    }
}

export function* usersPageSaga() {
    yield all([
        takeEvery(
            (a: LocationChangeAction) => a.type === LOCATION_CHANGE && UsersPageUrl.match(a.payload, true).isMatched,
            getUsers
        ),
        takeEvery(createUserAction.type, createUser),
        takeEvery(removeUserByIdAction.type, deleteUser)
    ]);
}
